import { useEffect, useState } from "react";
import Spinner from "../components/Spinner";
import Product from "../components/Product";

const Home = () => {
  const API_URL = "https://fakestoreapi.com/products";



  const [products,setProducts]=useState([]);
  const [loding,setLoding]=useState(false);


  async function fetchProductData(){
    setLoding(true);
    try {

      const data=await fetch(API_URL);
      const jsondata=await data.json();
      setProducts(jsondata);
      
    } catch (error) {
      console.log("error aa gya");
      setProducts([]);
    }
    setLoding(false);

  }

  useEffect(()=>{
    fetchProductData();
    console.log(products)
  },[])

  return <div className="w-3/4 min-w-[350px] mx-auto grid grid-cols-1 min-h-screen relative  sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 ">
            {
                loding? <Spinner/>:(

                  products.length < 0 ? (
                    <div>
                      No data found
                    </div>
                  ):
                  (
                    products.map((product)=>{

                     return <div key={product.id}>
                         <Product product={product}/>
                      </div>
                    

                  })
                  )

                )
            }
     </div>;
};

export default Home;
